import { DatabaseChangeType } from '@databases/types/redux';

import { numberFormatMap } from '../../../collab/convert-to-collab';
import { YJSChangeHandler } from '../../types';

export const setFieldSettingsNumberFormat: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_SETTINGS_NUMBER_FORMAT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.fieldsById[change.fieldId].numberFormat = numberFormatMap[change.newValue.format];
  });
};
